<template>
    <slot />
</template>

<style>
.odocs-spaced p {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}

.odocs-spaced p > *:not(:last-child) {
    margin-right: 0.5rem;
}
</style>
